<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text class="black--text">
        <v-container class="pa-5">
          <v-row>
            <v-col class="py-0 my-1" cols="12" md="4">
              <v-list-item class="px-0">
                <v-list-item-avatar color="secondary">
                  <v-icon dark>mdi-account-multiple</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <div><span class="caption grey--text">Jenjang</span></div>
                  <span class="info--text mb-0" style="font-size: 17px">
                    {{ $getDeepObj(initValue, 'm_jenjang.singkat') }} ({{
                      $getDeepObj(initValue, 'm_jenjang.keterangan')
                    }})
                  </span>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="4">
              <div><span class="caption grey--text">Nama Daerah</span></div>
              <span class="mb-0">
                {{ $getDeepObj(pspPeringkat, 'instansi.nama') }}
              </span>
            </v-col>
            <v-col cols="12" md="4">
              <div><span class="caption grey--text">Nama Penilai</span></div>
              <span class="mb-0">
                {{ $getDeepObj(akun, 'nama') }}
              </span>
            </v-col>
          </v-row>
          <v-divider class="my-5" />
          <v-row>
            <v-col cols="12" md="6">
              <h3>Kriteria Penilaian Pusat</h3>
              <v-divider class="my-1 blue" />
              <div class="mt-3">
                <div>
                  <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                    Persentase Total Bobot Penilaian <strong>(minimal 50%)</strong>
                  </span>
                </div>
                <template>
                  <v-text-field
                    v-if="mode === 'form'"
                    v-model="form.persen_pusat"
                    outlined
                    dense
                    hide-details
                    v-mask="'###'"
                    @change="onChangePersenPusat"
                  />
                  <div v-else class="grey lighten-3 py-1">
                    <span class="black--text title ma-2 my-4">{{ form.persen_pusat || 0 }}%</span>
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <v-alert
                  border="left"
                  colored-border
                  :color="isValidTotalPusat ? 'success' : 'error'"
                  :class="isValidTotalPusat ? 'bg-success' : 'bg-error'"
                  dense
                >
                  <span v-if="isValidTotalPusat"> Total Persentase Bobot Nilai <strong>sudah sesuai</strong> </span>
                  <span v-else> Total Persentase Bobot Nilai <strong>belum sesuai</strong> </span>
                </v-alert>
              </div>
              <div class="mt-3">
                <v-row no-gutters style="flex-wrap: nowrap">
                  <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto">
                    <div class="mt-5">
                      <v-icon large>mdi-lock</v-icon>
                    </div>
                  </v-col>
                  <v-col cols="11" class="flex-grow-1 flex-shrink-0">
                    <v-row>
                      <v-col cols="12" sm="12" md="8">
                        <div>
                          <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                            Nama Kriteria 1
                          </span>
                        </div>
                        <div class="grey lighten-3 py-1">
                          <span class="black--text subtitle-1 ma-2 my-4">Wawancara Panel</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <div>
                          <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                            Bobot Penilaian (%)
                          </span>
                        </div>
                        <template>
                          <div class="grey lighten-3 py-1">
                            <span class="black--text title ma-2 my-4">
                              {{ form.persen_pusat ? form.persen_pusat / 2 : 0 }}%
                            </span>
                          </div>
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <div class="mt-3">
                <v-row no-gutters style="flex-wrap: nowrap">
                  <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto">
                    <div class="mt-5">
                      <v-icon large>mdi-lock</v-icon>
                    </div>
                  </v-col>
                  <v-col cols="11" class="flex-grow-1 flex-shrink-0">
                    <v-row>
                      <v-col cols="12" sm="12" md="8">
                        <div>
                          <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                            Nama Kriteria 2
                          </span>
                        </div>
                        <div class="grey lighten-3 py-1">
                          <span class="black--text subtitle-1 ma-2 my-4">Simulasi Mengajar</span>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <div>
                          <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                            Bobot Penilaian (%)
                          </span>
                        </div>
                        <template>
                          <div class="grey lighten-3 py-1">
                            <span class="black--text title ma-2 my-4">
                              {{ form.persen_pusat ? form.persen_pusat / 2 : 0 }}%
                            </span>
                          </div>
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <h3>Kriteria Penilaian Dinas Daerah</h3>
              <v-divider class="my-1 blue" />
              <div class="mt-3">
                <div>
                  <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                    Persentase Total Bobot Penilaian <strong>(100% - Total BPDP)</strong>
                  </span>
                </div>
                <template>
                  <div class="grey lighten-3 py-1">
                    <span class="black--text title ma-2 my-4">
                      {{ form.persen_pusat ? 100 - Number(form.persen_pusat) : 0 }}%
                    </span>
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <v-alert
                  border="left"
                  colored-border
                  :color="isValidTotalDinas ? 'success' : 'error'"
                  :class="isValidTotalDinas ? 'bg-success' : 'bg-error'"
                  dense
                >
                  <span v-if="isValidTotalDinas"> Total Persentase Bobot Nilai <strong>sudah sesuai</strong> </span>
                  <span v-else> Total Persentase Bobot Nilai <strong>belum sesuai</strong> </span>
                </v-alert>
              </div>
              <template v-for="(item, id) in kriterias">
                <div class="mt-3" :key="id">
                  <v-row no-gutters style="flex-wrap: nowrap">
                    <v-col cols="1" class="flex-grow-1 flex-shrink-0 my-auto">
                      <div class="mt-5">
                        <v-icon
                          large
                          :color="mode === 'form' ? 'red' : ''"
                          @click="onDelKriteria(id)"
                          style="cursor: pointer"
                        >
                          {{ mode === 'form' ? 'mdi-close-circle' : 'mdi-lock' }}
                        </v-icon>
                      </div>
                    </v-col>
                    <v-col cols="11" class="flex-grow-1 flex-shrink-0">
                      <v-row>
                        <v-col cols="12" sm="12" md="8">
                          <div>
                            <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                              Nama Kriteria {{ id + 1 }}
                            </span>
                          </div>
                          <template>
                            <v-text-field
                              v-if="mode === 'form'"
                              outlined
                              dense
                              hide-details
                              v-model="kriterias[id]['nama']"
                            />
                            <div v-else class="grey lighten-3 py-1">
                              <span class="black--text subtitle-1 ma-2 my-4">{{ kriterias[id]['nama'] }}</span>
                            </div>
                          </template>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <div>
                            <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                              Bobot Penilaian (%)
                            </span>
                          </div>
                          <template>
                            <v-text-field
                              v-if="mode === 'form'"
                              v-model="kriterias[id]['persen']"
                              outlined
                              dense
                              hide-details
                              v-mask="'###'"
                            />
                            <div v-else class="grey lighten-3 py-1">
                              <span class="black--text subtitle-1 ma-2 my-4">{{ kriterias[id]['persen'] }}%</span>
                            </div>
                          </template>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </template>
              <div class="mt-3" v-if="mode === 'form'">
                <v-btn color="primary" class="elevation-1" @click="onAddKriteria" :disabled="kriterias.length === 3">
                  <v-icon left dark>
                    mdi-plus
                  </v-icon>
                  Kriteria
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0">
              <h3>Set Inputan Nilai Minimum</h3>
              <v-divider class="my-1 blue" />
              <p class="body-2 mb-0">
                Silakan inputkan nilai minimum yang nantinya bisa digunakan untuk menilai kriteria daerah tersebut.
                Nilai minimum tersebut nantinya sebagai acuan proses penilaian pada kriteria daerah yang dimaksud,
                dengan internval nilai kriteria daerah adalah <strong>{{ this.konfigurasi.nilai_min }}</strong>
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <div>
                <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                  Nilai Minimum (paling tinggi diisikan dengan {{ 100 - this.konfigurasi.nilai_min }})
                </span>
              </div>
              <template>
                <v-text-field
                  v-if="mode === 'form'"
                  v-model="form.konfigurasi.nilai_min"
                  outlined
                  dense
                  hide-details
                  v-mask="'##'"
                />
                <div v-else class="grey lighten-3 py-1">
                  <span class="black--text subtitle-1 ma-2 my-4">{{ form.konfigurasi.nilai_min }}</span>
                </div>
              </template>
            </v-col>
            <v-col cols="12" md="6">
              <div>
                <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                  Nilai Maksimum (terisi otomatis dari sistem)
                </span>
              </div>
              <div class="grey lighten-3 py-1">
                <span class="black--text subtitle-1 ma-2 my-4">{{ form.konfigurasi.nilai_max || 0 }}</span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    initValue: {
      default: () => null,
    },
    mode: {
      default: 'form',
    },
  },

  computed: {
    ...mapState('preferensi', {
      akun: (state) => Object.assign({}, state.data && state.data.akun),
      config: (state) => state.data?.config ?? {},
    }),

    ...mapState('peringkat', {
      pspPeringkat: (state) => (state && state.psp_peringkat) || {},
    }),

    konfigurasi() {
      return {
        nilai_min: Number(this.$getDeepObj(this.config, 'peringkat.rentang_nilai_dinas') || 0),
        min_sm: Number(this.$getDeepObj(this.config, 'peringkat.min_sm') || 0),
        min_ww: Number(this.$getDeepObj(this.config, 'peringkat.min_ww') || 0),
      };
    },

    isValidTotalDinas() {
      const pusat = Number(this.form.persen_pusat) || 0;
      const dinas = Number(this.form.persen_dinas) || 0;
      const total = pusat + dinas;

      return pusat >= 50 && total === 100;
    },

    isValidSm() {
      const sm = this.form.persen_sm || 0;
      return sm >= this.konfigurasi.min_sm && !!sm;
    },

    isValidWw() {
      const ww = this.form.persen_ww || 0;
      return ww >= this.konfigurasi.min_ww && !!ww;
    },

    isValidTotalPusat() {
      const pusat = this.form.persen_pusat || 0;
      return pusat >= 50 && pusat <= 100;
    },

    isValidNilaiMin() {
      const nilai = (this.form.konfigurasi && this.form.konfigurasi.nilai_min) || 0;
      return !!nilai && Number(nilai) <= 100 - this.konfigurasi.nilai_min;
    },
  },

  data() {
    return {
      form: { konfigurasi: {} },
      kriterias: [],
    };
  },

  methods: {
    reset() {
      this.$set(this, 'form', { konfigurasi: {} });
      this.$set(this, 'kriterias', []);
    },

    initForm(value) {
      this.$set(this.form, 'konfigurasi', { nilai_min: (value.konfigurasi && value.konfigurasi.nilai_min) || null });
      this.$set(this.form, 'persen_pusat', value.persen_pusat || null);
      this.$set(this.form, 'persen_dinas', value.persen_dinas || null);

      for (let i = 1; i <= 3; i++) {
        if (value[`kriteria_dinas_persen_${i}`]) {
          this.kriterias.push({
            nama: value[`kriteria_dinas_nama_${i}`] || null,
            persen: value[`kriteria_dinas_persen_${i}`] || null,
          });
        }
      }
    },

    onAddKriteria() {
      const pusat = Number(this.form.persen_pusat) || 0;
      const kriteria1 = Number((this.kriterias[0] && this.kriterias[0]['persen']) || 0);
      const kriteria2 = Number((this.kriterias[1] && this.kriterias[1]['persen']) || 0);
      const kriteria3 = Number((this.kriterias[2] && this.kriterias[2]['persen']) || 0);

      if (!this.isValidTotalPusat) {
        this.$error('Pastikan Persetase Bobot Penilaian Pusat telah valid !');
        return;
      }

      if (pusat + kriteria1 + kriteria2 + kriteria3 >= 100) {
        this.$error('Total Persentase Bobot Penilaian Pusat dan Daerah tidak boleh melebihi 100%');
        return;
      }

      this.kriterias.push({});
    },

    onDelKriteria(id) {
      this.kriterias.splice(id, 1);
    },

    onChangePersenPusat() {
      this.form.persen_dinas = 100 - this.form.persen_pusat;
    },

    onChangeNilai() {
      const rentang = Number(this.$getDeepObj(this.config, 'peringkat.rentang_nilai_dinas') || 0);
      this.form.konfigurasi.nilai_max = Number(this.form.konfigurasi.nilai_min) + rentang;
    },

    getPersenKriteria() {
      for (const id in this.kriterias) {
        this.form[`kriteria_dinas_nama_${Number(id) + 1}`] = this.kriterias[id]['nama'] || '';
        this.form[`kriteria_dinas_persen_${Number(id) + 1}`] = this.kriterias[id]['persen'] || '';
      }

      return this.form;
    },

    getErrors() {
      let msg = '';
      const mapMsg = {
        persen_pusat: 'Total Bobot Penilaian Pusat',
      };

      for (const key of Object.keys(mapMsg)) {
        if (!this.form[key]) {
          msg = mapMsg[key] || '';
        }
      }

      for (const id in this.kriterias) {
        if (!this.kriterias[id]['nama'] || !this.kriterias[id]['persen']) {
          msg = `${!this.kriterias[id]['nama'] ? 'Nama Kriteria' : 'Bobot'} Penilaian Dinas ke-${Number(id) +
            1} belum ditentukan`;
        }
      }

      const kriteria1 = Number((this.kriterias[0] && this.kriterias[0]['persen']) || 0);
      const kriteria2 = Number((this.kriterias[1] && this.kriterias[1]['persen']) || 0);
      const kriteria3 = Number((this.kriterias[2] && this.kriterias[2]['persen']) || 0);
      const dinas = this.form.persen_dinas || 0;

      if (!this.isValidNilaiMin) {
        msg = `Cek kembali inputan nilai minimum Anda. Nilai minimum yang dapat diinputkan adalah ${100 -
          this.konfigurasi.nilai_min}`;
      }

      if (kriteria1 + kriteria2 + kriteria3 > dinas) {
        msg = `Total nilai dari komponen kriteria dinas tidak boleh lebih dari ${this.form.persen_dinas}%`;
      }

      if (kriteria1 + kriteria2 + kriteria3 < dinas) {
        msg = `Total nilai dari komponen kriteria dinas tidak boleh kurang dari ${this.form.persen_dinas}%`;
      }

      if (!kriteria1 && !kriteria2 && !kriteria3 && dinas > 0) {
        msg = 'Detail persentase pada kriteria daerah belum diisikan';
      }

      if (!this.isValidTotalPusat) {
        msg = 'Total Bobot Penilaian Pusat tidak valid';
      }

      return msg;
    },
  },

  watch: {
    initValue: 'initForm',
    'form.konfigurasi.nilai_min': 'onChangeNilai',
  },
};
</script>
